import React from 'react'
import { bool, node, string } from 'prop-types'
import styles from './NavigationWrapper.module.scss'
import SmartLink from '@/component/Primitive/SmartLink'
import Container from '@/component/Primitive/Container'
import classNames from 'classnames'

const NavigationWrapper = ({
  children,
  id,
  label,
  lightLogoUrl,
  small,
  className
}) => (
  <nav
    id={id}
    className={classNames(styles.NavigationWrapper, className)}
    aria-label={label}
  >
    <Container className={styles.NavigationWrapperInner} center size="wide">
      <SmartLink
        as="/"
        to="/section"
        className={classNames(styles.Logo, small && styles.small)}
        title="Home"
      >
        <img alt="" src={lightLogoUrl} />
      </SmartLink>
      <ul className={styles.NavigationList}>{children}</ul>
    </Container>
  </nav>
)

NavigationWrapper.propTypes = {
  children: node.isRequired,
  id: string,
  label: string,
  className: string,
  lightLogoUrl: string,
  small: bool
}

export default NavigationWrapper
